
import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export const useSharedFolderHandling = () => {
  const navigate = useNavigate();
  const [isSharedFolder, setIsSharedFolder] = useState<boolean>(false);

  // Fetch project id for a shared folder
  const fetchProjectIdForSharedFolder = useCallback(async (folderId: string): Promise<string | null> => {
    try {
      console.log("Fetching project ID for shared folder:", folderId);
      
      const { data, error } = await supabase
        .from("folders")
        .select("project_id")
        .eq("id", folderId)
        .single();

      if (error) {
        console.error("Error fetching project ID for shared folder:", error);
        toast.error("Kunde inte hämta projekt för delad mapp");
        return null;
      }

      if (data && data.project_id) {
        console.log("Found project ID for shared folder:", data.project_id);
        return data.project_id;
      }

      return null;
    } catch (error) {
      console.error("Error in fetchProjectIdForSharedFolder:", error);
      return null;
    }
  }, []);

  // Handle selecting a shared folder
  const handleSelectSharedFolder = useCallback(async (folderId: string) => {
    console.log("Selected shared folder:", folderId);
    setIsSharedFolder(true);
    navigate(`/uppdrag/shared/${folderId}`);
    return folderId;
  }, [setIsSharedFolder, navigate]);

  return {
    isSharedFolder,
    setIsSharedFolder,
    fetchProjectIdForSharedFolder,
    handleSelectSharedFolder
  };
};
